<div class="vehicle-capacity-container">
  <div class="header">
    <div class="col button-group">
      <form class="row toggle-group mt-10" [formGroup]="group">
        <mat-slide-toggle formControlName="useSelectedVehiclesForAll" [disabled]="isOptimizing">Reuse Available Vehicles</mat-slide-toggle>
        <mat-slide-toggle [matTooltip]="'Use fixed vehicle cost for different capacities'" formControlName="useVehicleCosts" [disabled]="isOptimizing">Use Vehicle Costs</mat-slide-toggle>
        <mat-slide-toggle [disabled]="true">My Vehicle Capacity</mat-slide-toggle>
        <mat-slide-toggle [disabled]="true">Marketplace</mat-slide-toggle>
      </form>

      <div class="row mt-10 add-capacity" *ngIf="!isOptimizing">
        <mat-menu #menu="matMenu">
          <button class="menu-btn" mat-menu-item
            *ngFor="let containerCategory of internalVehicleCategories | keyvalue"
            (click)="setExternalType(containerCategory.key)">
              {{containerCategory.key}}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <!-- Global Capacity Utilization Slider -->
  <div class="global-capacity-slider" [class.disabled]="isOptimizing">
    <label class="capacity-label">Vehicle Capacity Utilization</label>
    <div class="utilization-controls">
      <div class="slider-row">
        <input 
          type="range"
          min="0"
          max="100"
          step="1"
          [(ngModel)]="globalCapacityUtilization"
          (input)="!isOptimizing && updateGlobalCapacityUtilization(globalCapacityUtilization)"
          (change)="!isOptimizing && updateGlobalCapacityUtilization(globalCapacityUtilization)"
          [style.background]="'linear-gradient(to right, #6361DA 0%, #6361DA ' + globalCapacityUtilization + '%, #E0E0E0 ' + globalCapacityUtilization + '%, #E0E0E0 100%)'"
          [disabled]="isOptimizing"
          class="utilization-slider html-range-slider">
        <div class="utilization-input-container">
          <input type="number" min="0" max="100" 
            [(ngModel)]="globalCapacityUtilization" 
            (change)="!isOptimizing && updateGlobalCapacityUtilization(globalCapacityUtilization)"
            [disabled]="isOptimizing"
            class="number-input">
          <span class="percent-symbol">%</span>
        </div>
      </div>
      <div class="slider-labels">
        <span>0%</span>
        <span>100%</span>
      </div>
    </div>
  </div>

  <!-- Standard Vehicles Section -->
  <div class="digital-twin">
    <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding-right: 16px;">
      <h3 style="margin: 0;">Standard Vehicles</h3>
      <button mat-raised-button color="primary" type="button" (click)="!isOptimizing && openAddStandardVehicle()" [disabled]="isOptimizing" style="margin-left: auto;">
        <mat-icon>add</mat-icon>
        Add Vehicle
      </button>
    </div>
    <div class="standard trucks-container">
      <div class="container-category-container">
        <div *ngFor="let containerCategory of standardVehicleCategories | keyvalue">
          <div class="container-category">
            <div class="category-content">
              <span>{{containerCategory.key}}</span>
              <span class="container-count">{{getSelectedVehicleCount('STANDARD', containerCategory.key)}}</span>
            </div>
            <div class="edit" *ngIf="!isOptimizing" (click)="editVehicleCategory('STANDARD', containerCategory.value.count, containerCategory.key)">
              <mat-icon>edit</mat-icon>
            </div>
            <div class="edit edit-disabled" *ngIf="isOptimizing">
              <mat-icon>edit</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Digital Twin Section -->
  <div class="digital-twin">
    <h3>Digital Twin</h3>
    
    <!-- Internal Vehicles Section -->
    <div class="internal trucks-container">
      <span>Internal</span>
      <div class="container-category-container">
        <div *ngFor="let containerCategory of internalVehicleCategories | keyvalue">
          <div class="container-category">
            <div class="category-content">
              <span>{{containerCategory.key}}</span>
              <span class="container-count">{{getSelectedVehicleCount('INTERNAL', containerCategory.key)}}</span>
            </div>
            <div class="edit" *ngIf="!isOptimizing" (click)="editVehicleCategory('INTERNAL', containerCategory.value.count, containerCategory.key)">
              <mat-icon>edit</mat-icon>
            </div>
            <div class="edit edit-disabled" *ngIf="isOptimizing">
              <mat-icon>edit</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- External Vehicles Section -->
    <div class="external trucks-container">
      <span>External</span>
      <div class="container-category-container">
        <div *ngFor="let containerCategory of externalVehicleCategories | keyvalue">
          <div class="container-category">
            <div class="category-content">
              <span>{{containerCategory.key}}</span>
              <span class="container-count">{{getSelectedVehicleCount('EXTERNAL', containerCategory.key)}}</span>
            </div>
            <div class="edit" *ngIf="!isOptimizing" (click)="editVehicleCategory('EXTERNAL', containerCategory.value.count, containerCategory.key)">
              <mat-icon>edit</mat-icon>
            </div>
            <div class="edit edit-disabled" *ngIf="isOptimizing">
              <mat-icon>edit</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
